import reducer from './reducer';
import {NAME} from './constants';
import reducerRegistry from '../utils/reducerRegistry';
import {getToken, getIsAdmin, getHome, getIsConfirmed, getIsSysAdmin, getIsExpired, getAuth, getIsVerifier} from "./selectors";

reducerRegistry.register(NAME, reducer);

export {getToken, getIsAdmin, getHome, getIsConfirmed, getIsSysAdmin, getIsExpired, getAuth, getIsVerifier};